module.exports = __webpack_public_path__ + "static/media/ARIALI 1.97f1aa85.TTF";